enum MenuItemFilterSection {
  DispensaryName = "dispensary_name",
  THCLevel = "thc",
  PriceRange = "filterable_price",
  Deals = "deal_active",
}

export default MenuItemFilterSection;
